export const LAYOUT_EMPTY = 'empty';
export const LAYOUT_CONTAINER_SMALL = 'container-small';
export const LAYOUT_CONTAINER_MEDIUM = 'container-medium';
export const LAYOUT_CONTAINER_FULL = 'container-full';
// De publieke schil uit ui-v1: topnav, mobiele nav, breadcrumbs en footer.
export const LAYOUT_PUBLIC = 'public';
export const GLOBAL_PREFIX = '/ui/v2';
